import React from "react";
import { useHistory } from "react-router-dom";
import { Text, i18n, tokens } from "@simplybenefits/sb-ui-library";
import Grid from "@mui/material/Grid";
import Tile from "./Tile.js";
import pocketPillsImage from "../../assets/pocketpills-icon.png";
import enrichedAcademyImage from "../../assets/enriched-academy-icon.png";
import fyiDoctorsImage from "../../assets/fyi-doctors-small.png";

/**
 * Check if user is eligible for Enriched Academy
 */
const isEnrichedAcademyEligible = (user, coverage) => !user.isDependent
        && coverage.financialAwareness.benefitActive === 1
        && coverage.financialAwareness.isEligible === 1
        && coverage.financialAwareness.includeEnrichedAcademy === 1;

/**
 * Get localized PocketPills URL
 */
const getPocketPillsUrl = () => i18n.locale === 'fr' 
    ? "https://www.pocketpills.com/fr/simplybenefits"
    : "https://www.pocketpills.com/simplybenefits";

/**
 * PerksList Component - Displays grid of available perks
 *
 * @param {Object} user - User data from Redux
 * @param {Object} coverage - Coverage data from Redux
 * @param {Object} whitelabel - Whitelabel config from Redux
 * @param {Function} onEnrichedAcademyClick - Handler for Enriched Academy tile
 */
const PerksList = ({
    user,
    coverage,
    whitelabel,
    onEnrichedAcademyClick
}) => {
    const history = useHistory();

    /**
     * Helper to navigate to the FYI Doctors details page
     */
    const navigateToFYIDoctors = () => history.push('/perks/fyi-doctors');
    const showEnrichedAcademy = isEnrichedAcademyEligible(user, coverage);
    const pocketPillsUrl = getPocketPillsUrl();

    return (
        <>
            <Text medium>
                {i18n.t(tokens.labels.perks.enjoyExclusiveOffers)}
            </Text>
            
            <Grid 
                container 
                columnSpacing={4.5} 
                rowSpacing={4.25} 
                style={{ marginTop: -10 }}
            >
                {showEnrichedAcademy && (
                    <Tile
                        title="Enriched Academy"
                        isIncludedInPlan
                        icon={enrichedAcademyImage}
                        description={i18n.t(tokens.labels.perks.enrichedAcademyDescription)}
                        navigation={onEnrichedAcademyClick}
                        whitelabel={whitelabel}
                    />
                )}

                <Tile
                    title="Pocketpills"
                    icon={pocketPillsImage}
                    description={i18n.t(tokens.labels.perks.pocketPillsDescription)}
                    navigation={pocketPillsUrl}
                    whitelabel={whitelabel}
                />

                <Tile
                    title="FYidoctors"
                    icon={fyiDoctorsImage}
                    description={i18n.t(tokens.labels.perks.fyiDoctorsDescription)}
                    navigation={navigateToFYIDoctors}
                    whitelabel={whitelabel}
                    customIconStyle={{ width: 35, height: 41 }}
                />
            </Grid>
        </>
    );
};

export default PerksList;